import { render, staticRenderFns } from "./CreateFooterAddress.vue?vue&type=template&id=55edb5d2&scoped=true"
import script from "./CreateFooterAddress.vue?vue&type=script&lang=ts"
export * from "./CreateFooterAddress.vue?vue&type=script&lang=ts"
import style0 from "./CreateFooterAddress.vue?vue&type=style&index=0&id=55edb5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55edb5d2",
  null
  
)

export default component.exports